import React from 'react';
import { LinkProps } from 'react-router-dom';

export const InternalLinkContext = React.createContext<{ Link: React.FunctionComponent<LinkProps> }>({
  Link: (props) => <a {...props} href={props.to as string} />,
});
